import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest
} from 'redux-saga/effects'

import {
  getRequest
} from 'helpers/RequestUtil'

import {
  FETCH_NVBUGS,
  FETCH_LIMIT
} from './constants'

import {
  fetchNvbugsStart,
  fetchNvbugsSuccess,
  fetchNvbugsError,
  updateNvbugs,
} from './actions'

import {
  nvbugsPagesFetchedSelector
} from './selectors'

function* fetchNvbugs({ id }) {
  try {
    const curPage = yield select(nvbugsPagesFetchedSelector)

    yield put(fetchNvbugsStart())
    const { data } = yield call(
      getRequest,
      `/api/fulcrum/projects/${id}/nvbugs?page=${curPage + 1}&limit=${FETCH_LIMIT}`
    )

    yield put(updateNvbugs(data))
    yield put(fetchNvbugsSuccess())

  } catch(error) {
    console.log(error)
    yield put(fetchNvbugsError(error))
  }
}

function* watchFetchNvbugs(){
  yield takeLatest(FETCH_NVBUGS, fetchNvbugs)
}

function* loadSagas() {
  yield all([
    fork(watchFetchNvbugs)
  ])
}

export default loadSagas
